import { render, staticRenderFns } from "./LeadReport.vue?vue&type=template&id=6b897550&scoped=true"
import script from "./LeadReport.vue?vue&type=script&lang=js"
export * from "./LeadReport.vue?vue&type=script&lang=js"
import style0 from "./LeadReport.vue?vue&type=style&index=0&id=6b897550&prod&lang=css"
import style1 from "./LeadReport.vue?vue&type=style&index=1&id=6b897550&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b897550",
  null
  
)

export default component.exports